"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMount = useMount;
var react_1 = require("react");
/**
 * This is a temporal hook to mimic the component did mount without throwing the linter warning.
 * We consider that the current approach to prevent the warning makes code not readable and clean, so we will revisit
 * this later on, we also consider that the mount life cycle may be safe and should not introduce bugs.
 *
 * Other useEffect calls should follow the hooks rules.
 *
 * See https://github.com/facebook/create-react-app/issues/6880
 *
 * @param {EffectCallback} fn
 */
function useMount(fn) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, react_1.useEffect)(fn, []);
}
